module.exports = {
    appyShopConfig: {
        apiUrl: 'https://appyshop.fr/api/core/',
        revalidateData: 120,
        reCaptchaKey: "6Lddd7EaAAAAAILCYT0rhlQi3E70NPH_Uc8yuGei"

    }
}
